<template>

    <form method="POST" :action="route">
        <input type="hidden" name="_token" :value="token">
            <table class="abc-table mx-auto text-center" style="width:100%;">
                <thead class="abc-title-table">
                    <tr style="border-bottom: 3px solid #1e1e1e; font-size: 12px!important;">
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;" class="step1">Pays</th>
                        <th class="py-3" style="width: 24%; vertical-align: middle; color: #1e1e1e;">Secteur</th>
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;">Titres</th>
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;">Score climatique</th>
                        <th style="width: 4%; vertical-align: middle; color: #1e1e1e;"></th>
                        <th style="width: 24%; vertical-align: middle; color: #1e1e1e;"></th>
                        <th style="width: 4%; vertical-align: middle;"></th>
                    </tr>
                </thead>
                <tbody >
                    <tr v-for="(project, index) in projs" :key="index" style="border-bottom: 1px solid rgba(30, 30, 30, .1);">
                        <!-- <input type="hidden"
                            :name="'form[' + index + '][id]'"
                            :value="project.id "> -->
                        <td style="vertical-align: middle; width:24%;">
                            <select
                                class="form-control-4"
                                style="font-size:11px; width: 100%; text-transform: capitalize;"
                                v-model="project.country">
                                <option value="null" disabled>Selectionner le pays</option>
                                <option v-for="country in counts" :key="country.id" :value="country">{{ country.name }}</option>
                            </select>

                            <!-- <input
                                v-if="project.country != null"
                                type="hidden"
                                style="font-size:11px;"
                                :name="'form[' + index + '][country_id]'"
                                :value="project.country.id "> -->
                        </td>
                        <td class="py-3 px-2" style="vertical-align: middle; width:24%;">
                            <select
                                class="form-control-4"
                                style="font-size:11px; width:100%; text-transform:capitalize;"
                                v-model="project.sector">
                                <option value="null" disabled>Selectionner le secteur</option>
                                <option v-for="sector in filteredSector(project)" :key="sector.id" :value="sector" >{{ sector.name }} </option>
                            </select>

                            <!-- <input
                                v-if="project.sector != null"
                                type="hidden"
                                :name="'form[' + index + '][client_category_id]'"
                                :value="project.sector.id "> -->
                        </td>
                        <td class="px-2" style="vertical-align: middle; width:24%;">
                            <select
                                    class="form-control-4"
                                    style="font-size:11px; width:100%; text-transform:capitalize;"
                                    v-model="project.security">
                                    <option value="null" disabled>Selectionner le titre</option>
                                    <option v-for="security in filteredSecurity(project)" :key="security.id" :value="security">{{ security.name }} {{ security.esg_score }}</option>
                            </select>

                            <!-- <input type="hidden"
                                v-if="project.security != null"
                                style="font-size:11px; text-transform:capitalize;"
                                :name="'form[' + index + '][service_id]'"
                                :value="project.security.id " -->
                        </td>
                        <td class="px-2" style="vertical-align: middle; width:24%;">
                            <div v-if="project.security != null" class="font-weight-bold pb-2" style="color: rgb(187, 134, 252)">
                                {{ project.security.esg_score }}
                            </div>
                            <div v-else class="font-weight-bold pb-2" style="color: rgb(187, 134, 252)">
                                {{ project.esg_score }}
                            </div>
                        </td>
                        <td v-if="project.security != null" class="px-2" style="vertical-align: middle; width:4%;">
                            <button class="btn-alt-2-explain" v-b-modal="'info'" style="display: inline-block;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-question-circle mb-1" viewBox="0 0 16 16">
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                    <path d="M5.255 5.786a.237.237 0 0 0 .241.247h.825c.138 0 .248-.113.266-.25.09-.656.54-1.134 1.342-1.134.686 0 1.314.343 1.314 1.168 0 .635-.374.927-.965 1.371-.673.489-1.206 1.06-1.168 1.987l.003.217a.25.25 0 0 0 .25.246h.811a.25.25 0 0 0 .25-.25v-.105c0-.718.273-.927 1.01-1.486.609-.463 1.244-.977 1.244-2.056 0-1.511-1.276-2.241-2.673-2.241-1.267 0-2.655.59-2.75 2.286zm1.557 5.763c0 .533.425.927 1.01.927.609 0 1.028-.394 1.028-.927 0-.552-.42-.94-1.029-.94-.584 0-1.009.388-1.009.94z"/>
                                </svg>
                            </button>
                            <b-modal
                                title="Plus d'info sur ce titre ?"
                                class="modal fade alt-list" :id="'info'"
                                tabindex="-1"
                                role="dialog"
                                aria-labelledby="alternatives"
                                aria-hidden="true"
                                :header-bg-variant="headerBgVariant"
                                :header-text-variant="headerTextVariant"
                                :body-bg-variant="bodyBgVariant"
                                :body-text-variant="bodyTextVariant"
                                :footer-bg-variant="footerBgVariant"
                                :footer-text-variant="footerTextVariant"
                                ok-only
                            >
                                <p class="light-white-03">Description: {{ project.security.wikipedia_description }}</p>
                                <p class="light-white-03"># Employés {{ project.security.employees }}</p>
                                <p class="light-white-03">Site web: {{ project.security.website }}</p>
                                <p class="light-white-03">Capitalisation boursière:{{ project.security.market_cap }}</p>
                            </b-modal>
                        </td>
                        <td class="px-2" style="vertical-align: middle; width:24%;">
                            <a v-if="project.security != null" class="mb-0 light-blue-01 fts-12" :href="'/security/esg/ranking/'+project.security.isin">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"/>
                                </svg>
                                Noter ce titre
                            </a>
                        </td>
                        <td style="vertical-align: middle; width:4%;">
                            <button
                                style="font-size: 32px!important; text-align:center; vertical-align:middle; color:red;"
                                v-if="!project.disabled"
                                type="button"
                                class="close"
                                aria-label="Close"
                                v-on:click="projs.splice(projs.indexOf(project), 1)">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        <div class="row justify-content-center" style="padding-bottom: 20px;">
            <div class="col-md-6 px-4 my-3">
                <div class="mr-auto" style="width: max-content;">
                    <button type="button" class="btn-abc" style="padding:10px;" v-on:click="addRaw">
                        <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-plus-circle mr-2" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                            <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                        </svg>
                        Ajouter un titre
                    </button>
                </div>
            </div>
            <div class="col-md-6 px-4 my-3">
                <div class="ml-auto" style="width: max-content;">
                    Score total = {{ total }}
                </div>
            </div>
            <div class="col-md-6 px-4 my-3">
                <div class="ml-auto" style="width: max-content;">
                    Pour info, le score du CAC 40 est - {{ cac40.esg_score }}
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    export default {
        props: [
            'securities',
            'countries',
            'cac40',
            'sectors',
            'token',
            'route',
        ],

        data() {
            return {
                form: [],
                secs:[],
                sects:[],
                projs:[],
                counts: [],
                variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark'],
                headerBgVariant: 'info',
                headerTextVariant: 'light',
                bodyBgVariant: 'dark',
                bodyTextVariant: 'dark',
                footerBgVariant: 'info',
                footerTextVariant: 'dark'
            }
        },

        mounted() {
            this.securities.forEach(security =>
            {
                this.secs.push(security)
                if (!this.counts.find(element => element.id == security.country.id))
                {
                    this.counts.push(security.country);
                }
                if (!this.sects.find(element => element.id == security.sector.id))
                {
                    this.sects.push(security.sector);
                }
            });

            this.counts.sort((a, b) =>
                {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                },
            );

            this.secs.sort((a, b) =>
                {
                    if (a.esg_score > b.esg_score)
                        return -1;
                    if (a.esg_score < b.esg_score)
                        return 1;
                    return 0;
                },
            );

            this.sects.sort((a, b) =>
                {
                    if (a.name < b.name)
                        return -1;
                    if (a.name > b.name)
                        return 1;
                    return 0;
                },
            );
            this.addRaw();
            this.addRaw();
            this.addRaw();

        },

        computed: {
            total()
            {
                var tot = 0;
                this.projs.forEach(project =>
                {
                    if (project.security != null)
                    {
                        tot += project.security.esg_score
                    }
                });
                return tot;
            }
        },

        methods: {
            filteredSecurity(project){
                if (project.country != null && project.sector != null)
                {
                    return this.secs.filter(s => s.sector.name === project.sector.name).filter(s => s.country.name === project.country.name);
                }
                else
                {
                    return [];
                }
            },

            filteredSector(project){
                if (project.country != null)
                {
                    var sector = [];
                    this.secs.filter(s => s.country.name === project.country.name).forEach(security =>
                    {
                        if (!sector.find(element => element.id == security.sector.id))
                        {
                            sector.push(security.sector);
                        }
                    });
                    return sector;
                }
            },

            addRaw(){
                this.projs.push(
                {
                    id: null,
                    country: null,
                    sector: null,
                    security: null,
                    esg_score: 0,
                });
            }
        }
    }

</script>